module.exports = __webpack_public_path__ + "static/media/orange_circle.8b5ae2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/orange_circle.png
// module id = 1128
// module chunks = 0